import React from 'react'
import styled from '@emotion/styled'
import {SpacingPropsType} from 'types/Layout'

import {cssTheme} from '../../../themes'

export type DividerOrientation = 'horizontal' | 'vertical'

interface Props {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** The size of the left and right margins for horizontal dividers, or top and bottom margins for vertical dividers */
  sideMargin?: SpacingPropsType
  /** The component orientation */
  orientation?: DividerOrientation
}

const HorizontalDivider = styled.hr<{sideMargin: SpacingPropsType}>`
  height: 1px;
  width: 100%;
  flex-shrink: 0;
  border: none;
  background: ${cssTheme.colors.border.neutral.c100};
  background-clip: content-box;
  margin: 0;
  padding: 0 ${({sideMargin}) => cssTheme.layout.spacing[sideMargin]};
`

const VerticalDividerWrapper = styled.div<{
  sideMargin: SpacingPropsType
}>`
  background: ${cssTheme.colors.transparent};
  background-clip: content-box;
  height: 100%;
  align-self: stretch;
  padding: ${({sideMargin}) => cssTheme.layout.spacing[sideMargin]} 0;
`

const VerticalDividerElement = styled.div`
  width: 1px;
  height: 100%;
  min-height: 1px;
  background: ${cssTheme.colors.border.neutral.c100};
`

export const Divider = ({
  sideMargin = 's000',
  className,
  orientation = 'horizontal'
}: Props) => {
  if (orientation === 'vertical') {
    return (
      <VerticalDividerWrapper
        sideMargin={sideMargin}
        className={className}
        role="separator"
        aria-orientation="vertical"
      >
        <VerticalDividerElement />
      </VerticalDividerWrapper>
    )
  }

  return <HorizontalDivider sideMargin={sideMargin} className={className} />
}
